import { BaseEntity } from 'yt-ng-framework';

export class UserView extends BaseEntity {
    constructor(){
        super();
    }

    CompanyName: string = null;
    Email: string = null;
    FirstName: string = null;
    LastName: string = null;
    RoleName: string = null;
    LanguageName: string = null;
    UserName: string = null;
    IPAddress: string = null;
    Phone: string = null;
    RegistrationDate: Date = null;
    LastLoginDate: Date = null;
    is_active: boolean = null;
    StatusColor:string;
    StatusTooltip:string;
    RoleID: number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Email = input.Email;
        this.CompanyName = input.CompanyName;
        this.FirstName = input.FirstName;
        this.LastName = input.LastName;
        this.RoleName = input.RoleName;
        this.LanguageName = input.LanguageName;
        this.UserName = input.UserName;
        this.IPAddress = input.IPAddress;
        this.Phone = input.Phone;
        this.RegistrationDate = input.RegistrationDate;
        this.LastLoginDate = input.LastLoginDate;
        this.is_active = input.is_active;
        this.StatusColor=input.StatusColor;
        this.StatusTooltip= input.StatusTooltip;
        this.RoleID = input.RoleID;
        return this;
    }

    Serialize(input: UserView){
        return input;
    }
}